import React, { FC } from "react";
import { AlertTitle as MuiAlertTitle } from "@mui/lab";

type Props = React.ComponentProps<typeof MuiAlertTitle>;

const AlertTitle: FC<Props> = (props) => {
    return <MuiAlertTitle {...props}/>
}

export default AlertTitle;